import { render } from "./p-phone-number.vue?vue&type=template&id=35841b56&scoped=true"
import script from "./p-phone-number.vue?vue&type=script&lang=js"
export * from "./p-phone-number.vue?vue&type=script&lang=js"

import "./p-phone-number.vue?vue&type=style&index=0&id=35841b56&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35841b56"],['__file',"src/components/p-phone-number.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35841b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35841b56', __exports__)) {
    api.reload('35841b56', __exports__)
  }
  
  module.hot.accept("./p-phone-number.vue?vue&type=template&id=35841b56&scoped=true", () => {
    api.rerender('35841b56', render)
  })

}


export default __exports__